import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import moment from "moment/moment";

const ModalVerOrcamento = ({ open, handleClose, data }) => {
  if (!data || !data.procedimentos) {
    return null;
  }

  const isBeneficiario = data.beneficio !== "Particular";
  const isMisto = data.orcamentoMisto === true;
  const isIsentoPagemento = data.total === 0;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-orcamento-title"
      aria-describedby="modal-orcamento-description"
    >
      <Box
        className={`fluxo-atendimento__modal__box ${
          data.beneficio === "Particular"
            ? "orcamento__modal"
            : "orcamento__modal--beneficiario"
        }`}
      >
        <span className="fluxo-atendimento__modal__titulo">
          Orçamento nr {data.codigo} {" - " + data.beneficio}{" "}
          {isMisto ? "(Misto)" : ""}{" "}
          {data.modalidadePagamento === "REEMBOLSO_CLIENTE"
            ? " - Orçamento de Reembolso"
            : ""}
          {isIsentoPagemento && (
            <span className="orcamentoIsentoTitleMessage">
              {" "}
              - Isento de Pagamento
            </span>
          )}
        </span>

        <span className="fluxo-atendimento__modal__designacao">Tratamento</span>
        <span className="fluxo-atendimento__modal__designacao">
          Dentes/Região
        </span>

        {isBeneficiario && (
          <span
            className="fluxo-atendimento__modal__designacao"
            style={{ textAlign: "right" }}
          >
            {data.instituicaoCobertura.nome}
          </span>
        )}

        <span
          className="fluxo-atendimento__modal__designacao"
          style={{ textAlign: "right" }}
        >
          {data.beneficio === "Particular" ? "Valor" : "Beneficiário"}
        </span>

        {data.procedimentos.map((proc, index) => (
          <React.Fragment key={index}>
            <span className="fluxo-atendimento__modal__cell">
              {proc.tratamento.designacao}
              {proc.faces.length > 0 && `- face(s) ${proc.faces.join(", ")}`}
              {proc.tratamento.fornecedor?.nome && (
                <span style={{ display: "block", fontSize: "0.75rem", color: "#9e9e9e" }}>
                  {proc.tratamento.fornecedor.nome}
                </span>
              )}
            </span>
            <span className="fluxo-atendimento__modal__cell">{proc.dente}</span>

            {isBeneficiario && (
              <span
                className="fluxo-atendimento__modal__cell"
                style={{ textAlign: "right" }}
              >
                {proc.valor_cobertura.toLocaleString("pt-BR")}
              </span>
            )}

            <span
              className="fluxo-atendimento__modal__cell"
              style={{ textAlign: "right" }}
            >
              {data.modalidadePagamento === "REEMBOLSO_CLIENTE"
                ? proc.preco_beneficiario === 0
                  ? proc.valor_cliente
                  : proc.preco_beneficiario.toLocaleString("pt-BR")
                : proc.valor_cliente.toLocaleString("pt-BR")}
            </span>
          </React.Fragment>
        ))}

        {data.observacoes && data.observacoes !== "undefined" && (
          <>
            <span className="fluxo-atendimento__modal__observacao-titulo">
              Observação
            </span>
            <textarea
              className="fluxo-atendimento__modal__textarea"
              cols="30"
              rows="4"
              readOnly
              defaultValue={data.observacoes ? data.observacoes : ""}
            />
          </>
        )}

        <div className="verOrcamentoModal__valorCredencialContainer">
          {isBeneficiario &&
          data.modalidadePagamento !== "REEMBOLSO_CLIENTE" ? (
            <div className="verOrcamentoModal__valorCredencialContainer__col">
              <div className="verOrcamentoModal__valorCredencialContainer__col__row">
                <span className="orcamento__modal__valores__descricao">
                  Credencial
                </span>
                <span className="orcamento__modal__valores__valor">
                  {data.nrCredencial ? data.nrCredencial : ""}
                </span>
              </div>
              <div className="verOrcamentoModal__valorCredencialContainer__col__row">
                <span className="orcamento__modal__valores__descricao">
                  Data Emissão
                </span>
                <span className="orcamento__modal__valores__valor">
                  {data.dataCredencial
                    ? moment(data.dataCredencial).format("DD/MM/YYYY")
                    : ""}
                </span>
              </div>
              <div className="verOrcamentoModal__valorCredencialContainer__col__row">
                <span className="orcamento__modal__valores__descricao">
                  Válido até
                </span>
                <span className="orcamento__modal__valores__valor orcamento__modal__valores__valor--total">
                  {data.dataCredencial
                    ? moment(data.dataCredencial)
                        .add(180, "days")
                        .format("DD/MM/YYYY")
                    : ""}
                </span>
              </div>
            </div>
          ) : (
            //Div vazia para formatação css
            <div className="verOrcamentoModal__valorCredencialContainer__col"></div>
          )}
          <div className="verOrcamentoModal__valorCredencialContainer__col">
            <div className="verOrcamentoModal__valorCredencialContainer__col__row">
              <span className="orcamento__modal__valores__descricao">
                Subtotal
              </span>
              <span className="orcamento__modal__valores__valor">
                {data.subtotal.toLocaleString("pt-BR")}$00
              </span>
            </div>
            {data.comMajoracao && (
              <div className="verOrcamentoModal__valorCredencialContainer__col__row">
                <span className="orcamento__modal__valores__descricao">
                  Majoração
                </span>
                <span className="orcamento__modal__valores__valor">
                  {data.majoracao.toLocaleString("pt-BR")}$00
                </span>
              </div>
            )}
            {isMisto && (
              <>
                <div className="verOrcamentoModal__valorCredencialContainer__col__row">
                  <span className="orcamento__modal__valores__descricao">
                    Total Particular
                  </span>
                  <span className="orcamento__modal__valores__valor">
                    {data.procedimentos
                      .reduce(
                        (acc, p) =>
                          acc +
                          (p.preco_beneficiario === 0 ? p.valor_cliente : 0),
                        0
                      )
                      .toLocaleString("pt-BR")}
                    $00
                  </span>
                </div>

                <div className="verOrcamentoModal__valorCredencialContainer__col__row">
                  <span className="orcamento__modal__valores__descricao">
                    Total Beneficiário
                  </span>
                  <span className="orcamento__modal__valores__valor">
                    {data.procedimentos
                      .reduce((acc, proc) => {
                        return acc + (proc.preco_beneficiario || 0);
                      }, 0)
                      .toLocaleString("pt-BR")}
                    $00
                  </span>
                </div>
              </>
            )}

            {data.modalidadePagamento === "REEMBOLSO_CLIENTE" && (
              <>
                <div className="verOrcamentoModal__valorCredencialContainer__col__row">
                  <span className="orcamento__modal__valores__descricao">
                    Total Reembolso
                  </span>
                  <span className="orcamento__modal__valores__valor">
                    {data.valorCobertura.toLocaleString("pt-BR")}
                    $00
                  </span>
                </div>

                <div className="verOrcamentoModal__valorCredencialContainer__col__row">
                  <span className="orcamento__modal__valores__descricao">
                    Total Cliente
                  </span>
                  <span className="orcamento__modal__valores__valor">
                    {data.subtotalCliente.toLocaleString("pt-BR")}
                    $00
                  </span>
                </div>
              </>
            )}

            <div className="verOrcamentoModal__valorCredencialContainer__col__row">
              <span className="orcamento__modal__valores__descricao">
                Desconto{" "}
                {data.tipoDesconto === "%"
                  ? ` (${data.percentagemDescontoOriginal}%) `
                  : ""}
              </span>
              <span className="orcamento__modal__valores__valor">
                {data.desconto.toLocaleString("pt-BR")}$00
              </span>
            </div>

            <div className="verOrcamentoModal__valorCredencialContainer__col__row">
              <span className="orcamento__modal__valores__descricao">
                Total
              </span>
              <span className="orcamento__modal__valores__valor orcamento__modal__valores__valor--total">
                {data.total.toLocaleString("pt-BR")}$00
              </span>
            </div>
          </div>
        </div>

        <div
          style={{
            gridColumn: "1/-1",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <span className="cancel-btn" onClick={handleClose}>
            Fechar
          </span>
        </div>
      </Box>
    </Modal>
  );
};

export default ModalVerOrcamento;
